import React from 'react';
import { ArmchairIcon, CalculatorIcon, FlameIcon, HammerIcon, PaintRollerIcon, RulerIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';
const ICONS = {
  hammer: HammerIcon,
  ruler: RulerIcon,
  flame: FlameIcon,
  armchair: ArmchairIcon,
  paint: PaintRollerIcon,
  calculator: CalculatorIcon
};

/* Colores de cada tomo, igual que en la portada del pack */
const TOMO_COLORS = ['bg-red-600', 'bg-blue-700', 'bg-green-700', 'bg-orange-600', 'bg-purple-700', 'bg-teal-700'];
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-ink" data-id="element-165" data-mp="5vb0ycmpyocp">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-166" data-mp="5vuktyvxjmtd">
        <p className="text-xs font-bold uppercase tracking-widest text-gold" data-id="element-167" data-mp="ktmysmltw35g">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-2 font-anton text-2xl uppercase leading-tight text-white sm:text-3xl" data-id="element-168" data-mp="frnvfcq3968i">
          6 tomos en un solo sistema, creados para aprender desde cero.
        </h2>
        <p className="mt-1 text-xs font-black uppercase leading-tight text-forge sm:text-sm" data-id="element-169" data-mp="3fasmnmqwoo9z">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-paper/80" data-id="element-170" data-mp="3kb6kyd2pgjut">
          No es simplemente otro ebook de herrería. Es una ruta de aprendizaje
          que organiza los conocimientos fundamentales para que comprendas qué
          aprender primero, qué viene después y cómo transformar materiales en
          muebles industriales.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-171" data-mp="6v8wiwlj7lz5">
          {tomos.map((tomo, i) => {
          const Icon = ICONS[tomo.icon];
          return <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full overflow-hidden rounded-lg bg-paper text-left text-ink" data-id="element-172" data-mp="bweo2r3gh373" data-mpi={i}>
                <span className={`flex w-14 flex-shrink-0 flex-col items-center justify-center gap-1 text-white ${TOMO_COLORS[i]}`} data-id="element-173" data-mp="27xqa0urov5ap">
                  <span className="text-xs font-bold uppercase tracking-wider" data-id="element-174" data-mp="2mnxh6ec8x1w3">
                    Tomo
                  </span>
                  <span className="font-anton text-3xl leading-none" data-id="element-175" data-mp="2vnarf9871uhv">
                    {i + 1}
                  </span>
                  <Icon size={13} aria-hidden="true" data-id="element-176" data-mp="2rm8uiz1r1uj2" />
                </span>
                <div className="p-2.5" data-id="element-177" data-mp="35lgrdlafwqk3">
                  <h3 className="sr-only" data-id="element-178" data-mp="35kfercdrzw09">Tomo {i + 1}</h3>
                  <p className="text-sm font-extrabold uppercase leading-tight" data-id="element-179" data-mp="30mdwgto6c0pu">
                    {tomo.title}
                  </p>
                  <p className="mt-0.5 text-xs leading-snug text-steel sm:text-sm" data-id="element-180" data-mp="1b8ijt9g4k80g">
                    {tomo.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-181" data-mp="3hw83a70maxw8">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}